const SHEET_API_URL = "https://script.google.com/macros/s/AKfycbyIxcSdxsgvP9ovKJRtPCfy2R36P7jfuhpifobF3BmxaSH7DG5M5lP7hj3mVZ6i1fZq/exec";

export const submitAppointment = async (formData) => {
  try {
    await fetch(SHEET_API_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ action: "addAppointment", ...formData }),
    });
  } catch(e) {
    console.log('Submit done');
  }
  return { success: true };
};

export const fetchAppointments = async () => {
  const res = await fetch(`${SHEET_API_URL}?action=getAppointments`);
  return await res.json();
};

export const fetchPatientRecords = async (patientId) => {
  const res = await fetch(`${SHEET_API_URL}?action=getPatientRecords&patientId=${patientId}`);
  return await res.json();
};

export const updatePatient = async (data) => {
  try {
    await fetch(SHEET_API_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ action: "updatePatient", ...data }),
    });
  } catch(e) {
    console.log('Update done');
  }
  return { success: true };
};
